'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('./styles.js');

var Styles = _interopRequireWildcard(_styles);

var _StoreLocatorMap = require('./StoreLocatorMap');

var _StoreLocatorMap2 = _interopRequireDefault(_StoreLocatorMap);

var _constants = require('../../util/constants');

require('nodelist-foreach-polyfill');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var google = window.google;

var StoreLocator = function (_React$Component) {
    _inherits(StoreLocator, _React$Component);

    function StoreLocator() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, StoreLocator);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StoreLocator.__proto__ || Object.getPrototypeOf(StoreLocator)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            locations: _this.props.locations,
            categories: _this.props.categories,
            activeCategories: _this.props.categories,
            mapURL: _this.props.mapURL,
            mapCenter: _this.props.mapCenter,
            centerMarker: _this.props.centerMarker,
            travelMode: _this.props.travelMode,
            travelModes: _this.props.travelModes,
            currentMarker: {},
            stylesheetDirectory: _this.props.stylesheetDirectory,
            directions: null,
            infoBoxIsOpen: false,
            infoBoxIsClickable: true,
            mapBounds: null,
            download: _this.props.download
        }, _this.centerMap = function () {
            // console.log('center map');
            var bounds = new window.google.maps.LatLngBounds();
            var markers = [].concat(_toConsumableArray(_this.state.locations));

            markers.forEach(function (marker) {
                var latLong = new window.google.maps.LatLng(marker.location.lat, marker.location.lng);
                bounds.extend(latLong);
            });

            _this.setState({ mapBounds: bounds }, function () {
                _this.state.map.fitBounds(_this.state.mapBounds);
            });
        }, _this.clearDirections = function () {
            _this.setState({ infoBoxIsOpen: false, directions: null });
            _this.centerMap();
        }, _this.getDrivingDirections = function (marker, travelMode) {
            var DirectionsService = new window.google.maps.DirectionsService();

            _this.setState({
                marker: marker,
                infoBoxIsOpen: true,
                infoBoxIsClickable: false
            });

            if (_this.state.marker) {
                var request = {
                    origin: _this.state.mapCenter,
                    destination: marker.location,
                    travelMode: 'DRIVING'
                };

                var getDirections = new Promise(function (resolve, reject) {
                    function getRequest() {
                        var attempts = 5;

                        DirectionsService.route(request, function (result, status) {
                            if (status === window.google.maps.DirectionsStatus.OK) {
                                resolve(result);
                            } else {
                                retryRequest(status);
                            }
                        });

                        function retryRequest(status) {
                            --attempts;

                            if (attempts <= 0) {
                                reject(status);
                                console.error('(currentReq) error fetching directions ' + status);
                            } else {
                                setTimeout(function () {
                                    getRequest();
                                }, 1000);
                            }
                        }
                    }
                    getRequest();
                });
                getDirections.then(function (result) {
                    _this.setState({
                        drivingDirections: result,
                        infoBoxIsClickable: true
                    });

                    if (travelMode === 'DRIVING') {
                        _this.setState({ travelMode: travelMode, directions: result });
                    }
                });
            }
        }, _this.getBicyclingDirections = function (marker, travelMode) {
            var DirectionsService = new window.google.maps.DirectionsService();

            _this.setState({
                marker: marker,
                infoBoxIsOpen: true,
                infoBoxIsClickable: false
            });

            if (_this.state.marker) {
                var request = {
                    origin: _this.state.mapCenter,
                    destination: marker.location,
                    travelMode: 'BICYCLING'
                };

                var getDirections = new Promise(function (resolve, reject) {
                    function getRequest() {
                        var attempts = 5;

                        DirectionsService.route(request, function (result, status) {
                            if (status === window.google.maps.DirectionsStatus.OK) {
                                resolve(result);
                            } else {
                                retryRequest(status);
                            }
                        });

                        function retryRequest(status) {
                            --attempts;

                            if (attempts <= 0) {
                                reject(status);
                                console.error('(currentReq) error fetching directions ' + status);
                            } else {
                                setTimeout(function () {
                                    getRequest();
                                }, 1000);
                            }
                        }
                    }
                    getRequest();
                });
                getDirections.then(function (result) {
                    _this.setState({
                        bicyclingDirections: result,
                        infoBoxIsClickable: true
                    });
                    if (travelMode === 'BICYCLING') {
                        _this.setState({ travelMode: travelMode, directions: result });
                    }
                });
            }
        }, _this.getWalkingDirections = function (marker, travelMode) {
            var DirectionsService = new window.google.maps.DirectionsService();

            _this.setState({
                marker: marker,
                infoBoxIsOpen: true,
                infoBoxIsClickable: false
            });

            if (_this.state.marker) {
                var request = {
                    origin: _this.state.mapCenter,
                    destination: marker.location,
                    travelMode: 'WALKING'
                };

                var getDirections = new Promise(function (resolve, reject) {
                    function getRequest() {
                        var attempts = 5;

                        DirectionsService.route(request, function (result, status) {
                            if (status === window.google.maps.DirectionsStatus.OK) {
                                resolve(result);
                            } else {
                                retryRequest(status);
                            }
                        });

                        function retryRequest(status) {
                            --attempts;

                            if (attempts <= 0) {
                                reject(status);
                                console.error('(currentReq) error fetching directions ' + status);
                            } else {
                                setTimeout(function () {
                                    getRequest();
                                }, 1000);
                            }
                        }
                    }
                    getRequest();
                });
                getDirections.then(function (result) {
                    _this.setState({
                        walkingDirections: result,
                        infoBoxIsClickable: true
                    });
                    if (travelMode === 'WALKING') {
                        _this.setState({ travelMode: travelMode, directions: result });
                    }
                });
            }
        }, _this.getAllDirections = function (marker, travelMode) {
            _this.setState({ travelMode: travelMode });
            _this.getDrivingDirections(marker, travelMode);
            _this.getWalkingDirections(marker, travelMode);
            _this.getBicyclingDirections(marker, travelMode);
        }, _this.setCategory = function (category) {
            var selectedCategories = [].concat(_toConsumableArray(_this.state.categories));
            var allLocations = [].concat(_toConsumableArray(_this.props.locations));
            var newLocations = [];

            if (category.id) {
                selectedCategories = [category];
                allLocations.forEach(function (location) {
                    if (location.categories.includes(category.id)) {
                        newLocations.push(location);
                    }
                });
            } else {
                newLocations = allLocations;
            }

            _this.setState({
                activeCategories: selectedCategories,
                locations: newLocations
            }, function () {
                _this.centerMap();
            });
        }, _this.setMap = function (map) {
            if (!_this.state.map) {
                _this.setState({ map: map });
            }
        }, _this.render = function () {
            return _react2.default.createElement(_StoreLocatorMap2.default, {
                mapStyles: _constants.MAP_STYLES,
                markers: _this.state.locations,
                marker: _this.state.marker,
                categories: _this.state.categories,
                activeCategories: _this.state.activeCategories,
                travelMode: _this.state.travelMode,
                travelModes: _this.state.travelModes,
                googleMapURL: _this.state.mapURL,
                mapCenter: _this.state.mapCenter,
                centerMarker: _this.state.centerMarker,
                containerElement: _react2.default.createElement(Styles.StoreLocatorMapContainer, null),
                loadingElement: _react2.default.createElement(Styles.LoadingElement, null),
                mapElement: _react2.default.createElement(Styles.MapElement, { infoBoxIsOpen: _this.state.infoBoxIsOpen }),
                setCategory: _this.setCategory,
                getAllDirections: _this.getAllDirections,
                getDrivingDirections: _this.getDrivingDirections,
                getWalkingDirections: _this.getWalkingDirections,
                getBicyclingDirections: _this.getBicyclingDirections,
                clearDirections: _this.clearDirections,
                setTravelMode: _this.setTravelMode,
                directions: _this.state.directions,
                drivingDirections: _this.state.drivingDirections,
                bicyclingDirections: _this.state.bicyclingDirections,
                walkingDirections: _this.state.walkingDirections,
                stylesheetDirectory: _this.state.stylesheetDirectory,
                infoBoxIsOpen: _this.state.infoBoxIsOpen,
                infoBoxIsClickable: _this.state.infoBoxIsClickable,
                mapBounds: _this.state.mapBounds,
                setMap: _this.setMap,
                centerMap: _this.centerMap,
                download: _this.state.download
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return StoreLocator;
}(_react2.default.Component);

StoreLocator.propTypes = {
    locations: _propTypes2.default.array,
    categories: _propTypes2.default.array,
    activeCategories: _propTypes2.default.array,
    mapURL: _propTypes2.default.string,
    mapCenter: _propTypes2.default.object,
    travelMode: _propTypes2.default.string,
    travelModes: _propTypes2.default.array,
    setCategory: _propTypes2.default.func,
    currentMarker: _propTypes2.default.object,
    stylesheetDirectory: _propTypes2.default.string,
    download: _propTypes2.default.any
};
StoreLocator.defaultProps = {
    locations: [],
    categories: [],
    activeCategories: [],
    mapURL: '',
    mapCenter: {},
    travelMode: 'DRIVING',
    travelModes: ['DRIVING', 'BICYCLING', 'WALKING'],
    currentMarker: {},
    stylesheetDirectory: '',
    infoBoxIsOpen: false,
    infoBoxIsClickable: true,
    directions: null,
    download: ''
};


var els = document.querySelectorAll('[data-locations]');

if (els) {
    els.forEach(function (el) {
        var props = {
            locations: JSON.parse(atob(el.dataset.locations)),
            categories: JSON.parse(atob(el.dataset.categories)),
            mapURL: el.dataset.mapUrl,
            mapCenter: JSON.parse(atob(el.dataset.mapCenter)),
            centerMarker: el.dataset.marker,
            stylesheetDirectory: el.dataset.stylesheetDirectory,
            download: JSON.parse(atob(el.dataset.download))
        };

        if (el.dataset.title) {
            props.title = el.dataset.title;
        }

        (0, _reactDom.render)(_react2.default.createElement(StoreLocator, props), el);
    });
}


// WEBPACK FOOTER //
// ./scripts/react/storelocator/StoreLocator.js